
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/160w-solar-panel",
      function () {
        return require("private-next-pages/160w-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/160w-solar-panel"])
      });
    }
  